export const SET_CURRENT_MOBILE_FILTER = "SET_CURRENT_MOBILE_FILTER";
export const SET_CURRENT_MOBILE_WIDGET = "SET_CURRENT_MOBILE_WIDGET";
export const TOGGLE_MOBILE_FILTER = "TOGGLE_MOBILE_FILTER";
export const SET_SCROLLED_CLASS = "SET_SCROLLED_CLASS";

export const setCurrentMobileWidget = (title, name) => {
    return {
        type: SET_CURRENT_MOBILE_WIDGET,
        payload: { title, name },
    };
};

export const setCurrentMobileFilter = args => {
    return {
        type: SET_CURRENT_MOBILE_FILTER,
        payload: args
    };
};

export const toggleMobileFilter = status => {
    return {
        type: TOGGLE_MOBILE_FILTER,
        payload: status
    };
};

export const setScrolledClass = arg => {
    return {
        type: SET_SCROLLED_CLASS,
        payload: arg
    }
}